const memoryStore = new Map();

export const MemoryStore = {
  get(key) {
    return memoryStore.get(key) ?? null;
  },
  set(key, value) {
    memoryStore.set(key, value);
  },
  remove(key) {
    memoryStore.delete(key);
  }
};